import { render, staticRenderFns } from "./Charpter_two.vue?vue&type=template&id=6ea4799e&scoped=true&"
import script from "./Charpter_two.vue?vue&type=script&lang=js&"
export * from "./Charpter_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4799e",
  null
  
)

export default component.exports